import { fetchGraphQL } from "@universityofmaryland/web-utilities-library/network";
function createGraphQLFetchStrategy(config) {
  const {
    endpoint,
    queries,
    transformResponse,
    transformCount,
    composeVariables
  } = config;
  return {
    /**
     * Fetch the total count of entries
     */
    fetchCount: async (variables) => {
      try {
        const query = queries.count || queries.entries;
        const response = await fetchGraphQL({
          url: endpoint,
          query,
          token: variables.token,
          variables
        });
        if (!response || !response.data || response.message) {
          if (response?.message) {
            console.error(`GraphQL Error: ${response.message}`);
          }
          return null;
        }
        return transformCount(response);
      } catch (error) {
        console.error("Fetch count error:", error);
        return null;
      }
    },
    /**
     * Fetch the actual entries
     */
    fetchEntries: async (variables) => {
      try {
        const response = await fetchGraphQL({
          url: endpoint,
          query: queries.entries,
          token: variables.token,
          variables
        });
        if (!response || !response.data || response.message) {
          if (response?.message) {
            console.error(`GraphQL Error: ${response.message}`);
          }
          return null;
        }
        return transformResponse(response);
      } catch (error) {
        console.error("Fetch entries error:", error);
        return null;
      }
    },
    /**
     * Compose API variables from feed props
     */
    composeApiVariables: (props) => {
      const {
        token,
        categories,
        numberOfColumnsToShow = 1,
        numberOfRowsToStart,
        getOffset,
        entriesToRemove,
        ids,
        isMediaTrained
      } = props;
      const baseVariables = {
        token,
        limit: numberOfColumnsToShow * numberOfRowsToStart,
        offset: getOffset ? getOffset() : 0
      };
      if (categories) {
        baseVariables.categories = categories;
      }
      if (entriesToRemove) {
        baseVariables.entriesToRemove = entriesToRemove;
      }
      if (ids) {
        baseVariables.ids = ids;
      }
      if (isMediaTrained !== void 0) {
        baseVariables.isMediaTrained = isMediaTrained;
      }
      if (props.expertId) {
        baseVariables.expertId = props.expertId;
      }
      if (composeVariables) {
        return composeVariables(baseVariables);
      }
      const defaultVariables = { ...baseVariables };
      if (categories) {
        defaultVariables.related = categories;
        delete defaultVariables.categories;
      }
      return defaultVariables;
    }
  };
}
export {
  createGraphQLFetchStrategy
};
//# sourceMappingURL=graphql.js.map
